import React from 'react';
import { TableSortLabel } from '@mui/material';

export interface SortableHeaderCellProps {
  label: string;
  active: boolean;
  direction: SortDirection;
  onSort: () => void;
  disabled?: boolean;
}

type SortDirection = 'asc' | 'desc';

const SortableHeaderCell: React.FC<SortableHeaderCellProps> = ({
  label,
  active,
  direction,
  onSort,
  disabled = false,
}) => {
  return (
    <TableSortLabel
      active={active}
      direction={active ? direction : 'asc'}
      onClick={disabled ? undefined : onSort}
      disabled={disabled}
    >
      {label}
    </TableSortLabel>
  );
};

export default SortableHeaderCell;
